/** A signed-in person held per browser tab, so one browser can hold several. Local only. */

const KEY = "nebulize.tab-session";

/** The people the local provider signs in as. A testing convenience, not a platform vocabulary. */
export const LOCAL_PEOPLE = [
  "viewer",
  "moderator",
  "streamer",
  "contestant1",
  "contestant2",
  "contestant3",
] as const;

export type LocalPerson = (typeof LOCAL_PEOPLE)[number];

export interface Held {
  credential: string;
  subject: string;
  expires_at: string;
}

function read(): Held | undefined {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw === null ? undefined : (JSON.parse(raw) as Held);
  } catch {
    return undefined;
  }
}

/** The credential this tab holds, for the one place that sets the header. */
export function heldCredential(): string | undefined {
  const held = read();
  if (held === undefined) return undefined;
  if (Date.parse(held.expires_at) <= Date.now()) {
    forget();
    return undefined;
  }
  return held.credential;
}

/** Who this tab is, or undefined when it holds nobody. */
export function heldSubject(): string | undefined {
  return read()?.subject;
}

export function forget(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    return;
  }
}

export function remember(held: Held): void {
  sessionStorage.setItem(KEY, JSON.stringify(held));
}
